/**
 * Navbar 相关逻辑的 composable
 */
export function useNavbar() {
  const route = useRoute()
  const userStore = useUserStore()

  const isLogged = computed(() => userStore.isLogged)

  /**
   * 判断是否为当前菜单
   * @param menuPath 菜单路径
   * @returns 是否为当前菜单
   */
  function isActive(menuPath: string): boolean {
    // 外链不参与站内高亮
    if (menuPath.startsWith('http://') || menuPath.startsWith('https://')) {
      return false
    }

    // 首页精确匹配
    if (menuPath === '/') {
      return route.path === '/'
    }

    // 其它页面：当前路由等于菜单路径，或以其作为前缀（子路由）
    return route.path === menuPath || route.path.startsWith(`${menuPath}/`)
  }

  /**
   * 处理用户退出
   */
  function handleLogout() {
    const loading = ElLoading.service({
      lock: true,
      text: '退出登录中...',
      background: 'rgba(0, 0, 0, 0.7)'
    })

    setTimeout(() => {
      loading.close()
      userStore.logout()
    }, 1000)
  }

  return {
    isLogged,
    isActive,
    handleLogout
  }
}

